<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="">Channels</label>
                    <v-select v-model="selectedChannels" @input="buildJson" label="channel_name" placeholder="Enable publishing on these channels" :options="channels" :multiple="true"></v-select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="">Version</label>
                    <v-select :value="selectedVersion" @input="buildVersion" label="name" placeholder="Choose version for import/export" :options="versions" ></v-select>
                </div>
            </div>
        </div>

        <price-defaults v-model="prices" @input="buildJson"></price-defaults>

        <div class="row">
            <div class="col-md-12 clearfix">
                <h3 class="sectionable">Configuration</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="row repeater-section">
                    <div class="col-12">
                        <fields-list v-model="fields" @input="buildJson" ref="fieldsList" :selected-version="selectedVersion"></fields-list>
                    </div>
                </div>
                <div class="row pb-0">
                    <div class="col-md-12 clearfix">
                        <h3 class="sectionable">JSON</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-11">
                        <div class="form-group">
                            <input type="text" name="config" class="form-control" v-model="json" id="config-json" placeholder="JSON Config">
                            <small v-if="jsonError" class="form-text text-warning">{{ jsonError }}</small>
                            <small v-if="jsonSuccess" class="form-text text-success">{{ jsonSuccess }}</small>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="form-group">
                            <a href="#" @click.prevent="copyToClipboard()" class="btn btn-outline-primary"><i class="fa fa-clipboard" aria-hidden="true"></i> </a>
                        </div>
                    </div>
                </div>
                <div class="row pb-0" v-if="hasAnyExportFeature">
                    <div class="col-md-12 clearfix">
                        <h3 class="sectionable">Export Settings</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col" v-if="hasProjectFeature">
                        <label class="">Project</label>
                        <div class="form-group">
                            <select v-model="selectedProject" @change="buildJson" class="form-control">
                                <option value="0">Select a Project</option>
                                <option :value="project.id" :key="project.id" v-for="(project) in projects">{{ project.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col" v-if="hasScheduleFeature">
                        <label class="">Schedule</label>
                        <div class="form-group">
                            <select class="form-control" v-model="schedule" @change="buildJson">
                                <option value="">Not Scheduled</option>
                                <option :value="'daily'">Daily</option>
                                <option :value="'monthly'">Monthly</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="hasFixedPathFeature">
                    <div class="col-md-11" >
                        <label class="">File Path</label>
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="filePath" @input="buildJson" id="file-path" placeholder="File Path">
                            <small v-if="filePathError" class="form-text text-warning">{{ filePathError }}</small>
                            <small v-if="filePathSuccess" class="form-text text-success">{{ filePathSuccess }}</small>
                        </div>
                    </div>
                    <div class="col-md-1 d-flex align-items-end">
                        <div class="form-group">
                            <a href="#" @click.prevent="copyProjectToClipboard()" class="btn btn-outline-primary"><i class="fa fa-clipboard" aria-hidden="true"></i> </a>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-md-8">
                        <label class="">Save File in Same Location</label>
                        <div class="form-group" style="width: 38px;">
                            <input class="form-control" type="checkbox" :checked="saveSameLocation" />
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.repeater-section{
    margin-bottom:30px;
}
</style>

<script>
import FieldsList from './fields-list.vue';
import PriceDefaults from './price-defaults.vue';
import vSelect from 'vue-select';

export default {
    props: {
        configJson: {
            type: String,
        },
        channels: {
            type: Array,
        },
        versions: {
            type: Array,
        },
        priceDefaults: {
            type: Object,
        },
        projects: {
            type: [Array, Object],
        },
    },
    components: {
        FieldsList,
        PriceDefaults,
        vSelect,
    },
    data() {
        return {
            json: this.configJson,
            fields: this.configJson && JSON.parse(this.configJson) ? JSON.parse(this.configJson).fields : [],
            selectedChannels: [],
            prices: this.priceDefaults,
            saveSameLocation: false,
            jsonError: '',
            jsonSuccess: '',
            selectedVersion: {
                id: 0,
                name: 'Master'
            },
            selectedProject: 0,
            filePath: null,
            filePathError: '',
            filePathSuccess: '',
            schedule: null,
        }
    },
    watch: {
        json() {
            try {
                this.fields = JSON.parse(this.json).fields;
                this.selectedChannels = this.getChannelsFromConfig(this.json);
                this.selectedVersion = this.getVersionFromConfig(this.json).name;
                this.prices = this.getPricesFromConfigAndDefaults(this.json);
                this.selectedProject = this.getProjectFromConfig(this.json);
                this.filePath = this.getFilePathFromConfig(this.json);
                this.schedule = this.getScheduleFromConfig(this.json);
                this.jsonError = '';
            } catch (e) {
                this.jsonError = e.message;
            }
        },
        jsonSuccess() {
            setTimeout(function() {
                this.jsonSuccess = '';
            }.bind(this), 3000);
        },
    },
    mounted() {
        this.selectedChannels = this.getChannelsFromConfig(this.json);
        this.selectedVersion = this.getVersionFromConfig(this.json).name;
        this.selectedProject = this.getProjectFromConfig(this.json);
        this.filePath = this.getFilePathFromConfig(this.json);
        this.schedule = this.getScheduleFromConfig(this.json);
        this.prices = this.getPricesFromConfigAndDefaults(this.json);
        $('.import-profile-loader').hide();
    },
    methods: {
        buildJson() {
            const mappedFields = this.fields.map(field => ({
                label: field.label,
                type: field.type,
                field: field.field,
            }));

            let selectedVersionId = this.selectedVersion.id ? this.selectedVersion.id : 0

            let config = {
                fields: mappedFields,
                defaults: {
                    version: selectedVersionId,
                    project: this.hasProjectFeature ? this.selectedProject : 0,
                    filePath: this.hasFixedPathFeature ? this.filePath : '',
                    schedule: this.hasScheduleFeature ? this.schedule : '',
                    channels: this.selectedChannels.map(channel => channel.id),
                    product_price:this.prices
                }
            };

            this.json = JSON.stringify(config);
        },
        buildVersion(newVal) {
            if (this.selectedVersion.id != newVal.id) {
                this.$refs.fieldsList.clearFields();

            }
            this.$refs.fieldsList.changeOptions(newVal.id);
            this.selectedVersion = newVal;
            this.buildJson();
        },
        getChannelsFromConfig(config) {
            let selected = [];
            try {
                if (typeof (JSON.parse(config).defaults) === 'undefined') {
                    return [];
                }
                if (typeof (JSON.parse(config).defaults.channels) === 'undefined') {
                    return [];
                }
                if (JSON.parse(config).defaults.channels.length > 0) {
                    for (const element of this.channels) {
                        if (JSON.parse(config).defaults.channels.indexOf(element.id) > -1) {
                            selected.push(element);
                        }
                    }
                }
            } catch(e){}
            return selected;
        },
        getVersionFromConfig(config) {
            let selected={
                id: 0,
                name: 'Master'
            }
            if (config==='') {
                return selected;
            }
            if (typeof(JSON.parse(config).defaults) === 'undefined') {
                return selected;
            }
            if (typeof(JSON.parse(config).defaults.version) === 'undefined') {
                return selected;
            }
            return {
                id: JSON.parse(config).defaults.version,
                name: this.versions[JSON.parse(config).defaults.version]
            }
        },
        getPricesFromConfigAndDefaults(config) {
            try {
                if (typeof (JSON.parse(config).defaults) === 'undefined') {
                    return {};
                }
                if (typeof (JSON.parse(config).defaults.product_price) === 'undefined') {
                    return {};
                }
                return {
                    ...this.priceDefaults,
                    ...this.prices,
                    ...JSON.parse(config).defaults.product_price
                }
            } catch(e){}
            return {};
        },
        getProjectFromConfig(config) {
            let selected= 0;

            if (config==='') {
                return selected;
            }
            if (typeof(JSON.parse(config).defaults) === 'undefined') {
                return selected;
            }
            if (typeof(JSON.parse(config).defaults.project) === 'undefined') {
                return selected;
            }
            return JSON.parse(config).defaults.project;
        },
        getFilePathFromConfig(config) {
            let filePath = null;

            if (config==='') {
                return filePath;
            }
            else
            {
                return JSON.parse(config)?.defaults?.filePath; 
            }
        },
        getScheduleFromConfig(config) {
            let schedule = null;

            if (config==='') {
                return schedule;
            }
            else
            {
                return JSON.parse(config)?.defaults?.schedule ?? ''; 
            }
        },
        copyToClipboard() {
            const copyText = document.getElementById("config-json");
            copyText.select();

            try {
                const successful = document.execCommand('copy');
                const msg = successful ? 'successfully' : 'unsuccessfully';
                this.jsonSuccess = 'Config was copied to the clipboard ' + msg;
            } catch (err) {
                this.jsonError = 'Something went wrong, unable to copy';
            }
        },
        copyProjectToClipboard() {
            const copyText = document.getElementById("file-path");
            copyText.select();

            try {
                const successful = document.execCommand('copy');
                const msg = successful ? 'successfully' : 'unsuccessfully';
                this.filePathSuccess = 'Path copied to the clipboard ' + msg;
            } catch (err) {
                this.filePathError = 'Something went wrong, unable to copy';
            }
        }
    },
    computed: {
        hasProjectFeature() {
            return this.$parent.isFeatureAllowed('profile_exporter_project');
        },
        hasScheduleFeature() {
            return this.$parent.isFeatureAllowed('profile_exporter_scheduler');
        },
        hasFixedPathFeature() {
            return this.$parent.isFeatureAllowed('profile_exporter_fixed_storage');
        },
        hasAnyExportFeature() {
            return this.hasProjectFeature || this.hasScheduleFeature || this.hasFixedPathFeature;
        },
    },
}
</script>
